import {reloadScripts} from "./utils";
import {getUndoManager} from "../store/UndoManager";
import {getAppEditorStore} from "../store/appEditorStore";

export const getDefaultCommands = () => {
    return {
        defaults: [{
            id: "undo",
            run: function (editor, sender) {
                // if (sender) sender.set("active", false);
                getUndoManager().undo();
            }
        }, {
            id: "redo",
            run: function (editor, sender) {
                // if (sender) sender.set("active", false);
                getUndoManager().redo();
            }
        }, {
            id: "set-device-desktop",
            run: function (editor, sender) {
                if (document.querySelector('.devices-mobile-btn').classList.contains('active')) {
                    document.querySelector('.devices-mobile-btn').classList.remove('active');
                    sender.attributes.attributes.class = 'active';
                }
                editor.setDevice('Desktop');
            }
        }, {
            id: "set-device-mobile",
            run: function (editor, sender) {
                if (document.querySelector('.devices-desktop-btn').classList.contains('active')) {
                    document.querySelector('.devices-desktop-btn').classList.remove('active');
                    sender.attributes.attributes.class = 'active';
                }
                editor.setDevice('Mobile');
            }
        }, {
            id: "common-modal-set-device-desktop",
            run: function (editor, sender) {
                if (document.querySelector('.common-modal-devices-mobile-btn').classList.contains('active')) {
                    document.querySelector('.common-modal-devices-mobile-btn').classList.remove('active');
                    sender.attributes.attributes.class = 'active';
                }
                editor.setDevice('Desktop');
            }
        }, {
            id: "common-modal-set-device-mobile",
            run: function (editor, sender) {
                if (document.querySelector('.common-modal-devices-desktop-btn').classList.contains('active')) {
                    document.querySelector('.common-modal-devices-desktop-btn').classList.remove('active');
                    sender.attributes.attributes.class = 'active';
                }
                editor.setDevice('Mobile');
            }
        }, {
            id: "reload-scripts",
            run: function (editor, sender) {
                const canvasWindow = editor.Canvas.getWindow();
                reloadScripts(canvasWindow);
            }
        }, {
            id: "add-table-insert-column-left",
            run: async function (editor, sender) {
                await getAppEditorStore().addTableColumn('left');
            }
        }, {
            id: "add-table-insert-column-right",
            run: async function (editor, sender) {
                await getAppEditorStore().addTableColumn('right');
            }
        }, {
            id: "add-table-insert-row-top",
            run: async function (editor, sender) {
                await getAppEditorStore().addTableRow('top');
            }
        }, {
            id: "add-table-insert-row-bottom",
            run: async function (editor, sender) {
                await getAppEditorStore().addTableRow('bottom');
            }
        }, {
            id: "delete-table-column",
            run: async function (editor, sender) {
                await getAppEditorStore().deleteTableColumn();
            }
        }, {
            id: "delete-table-row",
            run: async function (editor, sender) {
                await getAppEditorStore().deleteTableRow();
            }
        }, {
            id: "convert-img-link",
            run: async function (editor, sender) {
                await getAppEditorStore().convertImageToLink();
            }
        }, {
            id: "disconnect-img-link",
            run: async function (editor, sender) {
                await getAppEditorStore().convertLinkToImage();
            }
        }]
    };
}